import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addTokenToRequest(req));
  }

  private addTokenToRequest(req: HttpRequest<any>): HttpRequest<any> {
    const headers = req.headers
      .set('Content-Type', 'application/json')
      .set('api-key', environment.apiKey);

    return req.clone({ headers });
  }
}
